import $ from 'cash-dom';
import { debounce, throttle } from '../utilities/toolkit';

const validateEmail = (element) => {
	let value = element.value.trim();
	let group = $(element).closest('.input-group');
	let errorField = group.find('.input-group-error');
	let form = group.closest('form');
	let submitButton = form.find('[type="submit"]');

	// Lets ignore it if it's empty but don't validate it
	if (value.length == 0) {
		group.attr('data-valid', '');
		form.trigger('vaildate-form');
		errorField.html('email must be filled in');
		return false;
	}

	let domain = value.split('@')[1] || '';
	// Must contain @ and . chars to be a valid email
	if (value.indexOf('@') < 0 || domain.indexOf('.') < 0) {
		group.attr('data-valid', 'false');
		form.trigger('vaildate-form');
		errorField.html('email must be valid');
		return false;
	}

	// Value is good, reset fields
	group.attr('data-valid', 'true');
	form.trigger('vaildate-form');
	submitButton.prop('disabled', false);

	setTimeout(function () {
		errorField.html('');
	}, 200);
	return true;
};

let validateDelay = 1000;
let emailFields = $('[data-validate="email"] [type="email"]');

emailFields.on(
	'keyup',
	debounce(function (e) {
		validateEmail(e.target);
	}, validateDelay)
);
emailFields.on('change', function (e) {
	validateEmail(e.target);
});

$('[data-validate="form"]').on('vaildate-form', function (e) {
	let form = $(e.target);
	let submit = form.find('[type="submit"]');
	let validateFields = form.find('[data-validate]');

	for (let i = 0; i < validateFields.length; ++i) {
		if (validateFields.eq(i).attr('data-valid') != 'true') {
			submit.prop('disabled', true);
			return;
		}
	}

	submit.removeAttr('disabled');
});
